import { BuildType } from '@/services/ApiService.ts';
import { ActiveDocumentUploadResponse, StartDocumentUploadResponse } from '@/apiTypes/SkillInferenceTypes.ts';

export const skillInferenceApiEndpoints = (build: BuildType) => ({
    uploadDocument: build.mutation<StartDocumentUploadResponse, FormData>({
        query: formData => ({
            url: 'skills/infer',
            method: 'POST',
            body: formData,
        }),
        invalidatesTags: ['SkillInferenceUpload'],
    }),
    getActiveDocumentUpload: build.query<ActiveDocumentUploadResponse, void>({
        query: () => 'skills/infer',
        providesTags: ['SkillInferenceUpload'],
        keepUnusedDataFor: 0,
    }),
    completeInferenceJob: build.mutation<{ saved: number }, { skillIds: string[] }>({
        query: body => ({
            url: 'skills/infer/complete',
            method: 'POST',
            body,
        }),
        invalidatesTags: ['SkillInferenceUpload', 'UserSkills', 'UserJourneys'],
    }),
    retryInferenceJob: build.mutation<void, void>({
        query: () => ({
            url: 'skills/infer/retry',
            method: 'POST',
        }),
        invalidatesTags: ['SkillInferenceUpload'],
    }),
    cancelInferenceJob: build.mutation<void, void>({
        query: () => ({
            url: 'skills/infer/cancel',
            method: 'POST',
        }),
        invalidatesTags: ['SkillInferenceUpload'],
    }),
});
